"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutActionType = void 0;
var CheckoutActionType;
(function (CheckoutActionType) {
    CheckoutActionType["Authorization"] = "Authorization";
    CheckoutActionType["CardVerification"] = "Card Verification";
    CheckoutActionType["Void"] = "Void";
    CheckoutActionType["Capture"] = "Capture";
    CheckoutActionType["Refund"] = "Refund";
    CheckoutActionType["Payout"] = "Payout";
    CheckoutActionType["Return"] = "Return";
})(CheckoutActionType || (exports.CheckoutActionType = CheckoutActionType = {}));
//# sourceMappingURL=CheckoutActionType.js.map